import React from 'react';
import ReactDOM from 'react-dom/client';

import { register, unregister } from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

runServiceWorker();

root.render(<App />);

reportWebVitals();

function runServiceWorker() {
	if (process.env.NODE_ENV !== 'production') {
		return unregister();
	}

	register();
}
